import React from "react";
import ModalView from "@modals/modalview/ModalView";
import styles from "./AssignEvaluators.module.css";

interface AssignEvaluatorsProps {
    isOpen: boolean;
    onAssignEvaluators: () => void;
    onCancel: () => void;
    onClose: () => void;
}

function AssignEvaluators({
  isOpen,
  onAssignEvaluators,
  onCancel,
  onClose,
}: AssignEvaluatorsProps) {
  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      <div className={styles.modalContainer}>
        <div className={styles.header}>
          <h1>Assign Evaluators</h1>
        </div>
        <div className={styles.modalBody}>
          <p>
            You need to assign evaluators before continuing with this action.
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button
            className={styles.viewButton}
            onClick={onAssignEvaluators}
          >
            Assign Now
          </button>
        </div>
      </div>
    </ModalView>
  );
}

export default AssignEvaluators;
